import { useWatch } from "react-hook-form"
import type { FormValues } from "../../../UserForm.component"
import { fields } from "../GeneralInfos.fields"
import { isRPPSIdRequired } from "../GeneralInfos.rg"
import { useGetUserTypeField } from "./useGetUserTypeField"

export const useConditionalRppsField = () => {
  const type = useGetUserTypeField()
  const teamFunction = useWatch<FormValues, "teamFunction">({
    name: fields.teamFunction,
  })

  return {
    required: isRPPSIdRequired(type, teamFunction),
    hidden: type !== "HOLDER" && type !== "TEAM",
  }
}
